export const setInvoice = 'setInvoice'
export const setYapayData = 'setYapayData'
export const setPasswordYapay = 'setPasswordYapay'
export const setEmailYapay = 'setEmailYapay'
export const clearEmailYapay = 'clearEmailYapay'
export const clearPasswordYapay = 'clearPasswordYapay'
export const clearYapayData = 'clearYapayData'
export const setSplits = 'setSplits'



// WEBPACK FOOTER //
// ./src/app/pages/payments/vuex/mutations-types.js